import { useCallback, useState } from 'react'
import MeService from '../../services/me-service'
import swal from 'sweetalert'

const useFeedback = () => {
  const [feedback, setFeedback] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSend = useCallback(() => {
    try {
      setIsLoading(true)
      MeService.feedback({
        feedback,
        type: 'feedback-page',
      })
      setFeedback('')
      swal({
        title: 'Mesaj trimis',
        text: 'Mulțumim pentru feedback!',
        icon: 'success',
        timer: '2000',
        buttons: false,
      })
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }, [feedback])
  return { feedback, handleSend, setFeedback, isLoading }
}

export default useFeedback
